export default __webpack_public_path__ + "static/assets/med_x_spray_nasal_mask.945caae4.png";